export default __webpack_public_path__ + "static/topic19-7a93037d72f34976b2928b10ab5c5d04.png";